var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaseactive = function SvgBaseactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#baseactive_svg__a)",
    fillRule: "evenodd",
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 17.866a6.368 6.368 0 0 0-7.495-1.12c-.683.365-1.508-.084-1.508-.859V6.791c0-.636.294-1.248.812-1.617A6.367 6.367 0 0 1 13 5.86a6.367 6.367 0 0 1 8.192-.687c.518.369.812.981.812 1.617v9.096c0 .774-.825 1.225-1.509.86A6.368 6.368 0 0 0 13 17.866",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.505 20.884a6.368 6.368 0 0 1 7.496 1.12 6.368 6.368 0 0 1 7.495-1.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#baseactive_svg__b)",
    fillRule: "evenodd",
    d: "M13 17.866V5.861z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 17.866V5.861"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "baseactive_svg__a",
    x1: 13,
    x2: 13,
    y1: 3.996,
    y2: 17.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "baseactive_svg__b",
    x1: 13,
    x2: 13,
    y1: 5.861,
    y2: 17.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })))));
};
export { SvgBaseactive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZWEwYmJjZjYyMmNkOWYzODYxNGE4ZmI3NTllZTY4M2Muc3ZnIjs=";